import { create } from "zustand";
import { combine } from "zustand/middleware";

export interface AuthStoreState {
  user:
    | {
        id: string;
        username: string;
        userType: string;
        channels: {
          id: string;
          type: string;
          title?: string;
          users: unknown[];
          messages: unknown[];
          creation: string;
        }[];
        chatId: string;
        creation: string;
        sdbkey: string;
        ssessid: string;
        ssjwt: string;
        sldId: string;
        twoManRuleKey: string;
        assistant: unknown;
        doctor: unknown;
        patient: unknown;
        preferences: {
          id: string;
          code: string;
          valueString: string;
        }[];
      }
    | undefined;
  session:
    | {
        configMode: string;
        integrations: Record<string, unknown>;
        isAdmin: boolean;
        isCurrentUserAdmin: string;
        isImpersonation?: boolean;
        originalUserId?: string;
        originalUsername?: string;
        sessionHandle?: string;
      }
    | undefined;
}

const defaultValues: AuthStoreState = {
  user: undefined,
  session: undefined,
};

export const useAuthStore = create(
  combine(
    {
      ...defaultValues,
    },
    (set) => ({
      set,
      setUser: (user: AuthStoreState["user"]) => set(() => ({ user })),
      setSession: (session: AuthStoreState["session"]) =>
        set(() => ({ session })),
      updateUser: (user: Partial<AuthStoreState["user"]>) =>
        set((state) => ({ user: { ...state.user, ...user } })),
      pushChannel: (channel: AuthStoreState["user"]["channels"][number]) =>
        set((state) => ({
          user: { ...state.user, channels: [...state.user.channels, channel] },
        })),
      reset: () => set(() => ({ ...defaultValues })),
    })
  )
);
